import React from 'react'
import classNames from 'classnames'
import { Image } from '@/components/ui'
import { RadioButton } from '@/components/ui/ReactHookFormFields'
import type { TCommunicationMethodSelectorItemProps } from './types'
import './styles.scss'

export const CommunicationMethodSelectorItem = ({
  className,
  control,
  isSelected,
  label,
  value,
  image,
}: TCommunicationMethodSelectorItemProps): JSX.Element => (
  <RadioButton
    className={classNames(className, 'communicationMethodSelectorItem', isSelected && 'communicationMethodSelectorItem--selected')}
    name="communicationMethod"
    control={control}
    value={value}
    CustomLabel={<h5>{label}</h5>}
  >
    <Image className="communicationMethodSelectorItem__image" src={image} isInStatic />
  </RadioButton>
)
